var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7491 1.43115L4.32422 16.8519C4.65769 17.0144 5.02345 17.0998 5.3944 17.1017H8.03613C8.25713 17.1012 8.46915 17.189 8.62495 17.3458L10.0566 18.7766C10.833 19.5583 11.8889 19.9983 12.9906 19.9992C13.4455 19.9988 13.8973 19.9242 14.3282 19.7785C15.8136 19.2915 16.894 18.0038 17.1157 16.4563L19.9298 3.08934C20.0642 2.53237 20.0003 1.94604 19.7491 1.43115Z",
    fill: "#86D165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9343 0.0640137L3.59985 2.87318C1.32145 3.1862 -0.271809 5.28697 0.0412054 7.56536C0.164842 8.46513 0.579241 9.29986 1.22128 9.94225L2.6521 11.3731C2.80849 11.5294 2.89629 11.7416 2.89613 11.9627V14.6044C2.89804 14.9754 2.98346 15.3412 3.14598 15.6746L18.5683 0.249761C18.0615 0.000692428 17.4841 -0.0649322 16.9343 0.0640137Z",
    fill: "#86D165"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.a6b7dfbcb3db9adf8f3e1e99738ea8e2.svg";
export { ForwardRef as ReactComponent };